// NavMenu.js
import React, { useState } from "react";
import { NavLink, useLocation } from "react-router-dom";

import crane from '../assets/crane.png';
import white_crane from '../assets/crane_white.png';
import ivory_crane from '../assets/crane_ivory.png';

const NavMenu = () => {
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const location = useLocation()

  const toggleSidebar = () => {
    setIsSidebarOpen((prev) => !prev);
  };

  const closeSidebar = () => setIsSidebarOpen(false);

  const navPages = [
    { 'name': 'Home', 'link': '/' },
    { 'name': 'Schedule', 'link': '/schedule' },
    { 'name': 'Transportation', 'link': '/transportation' },
    { 'name': 'Hotel & Travel', 'link': '/hotel-and-travel' },
    { 'name': 'Wedding Party', 'link': '/wedding-party' },
    { 'name': 'Things To Do', 'link': '/things-to-do' },
    { 'name': 'FAQ', 'link': '/faq' },
    { 'name': 'Registry', 'link': '/registry' }
  ]

  const pinstripesColorForPage = (pathname) => {
    if (pathname == "/") {
      return "blue";
    } else if (pathname.startsWith("/schedule")) {
      return "green";
    } else if (pathname.startsWith("/hotel-and-travel")) {
      return "seersucker-blue";
    } else if (pathname.startsWith("/wedding-party")) {
      return "pink";
    } else if (pathname.startsWith("/things-to-do")) {
      return "green";
    } else if (pathname.startsWith("/faq")) {
      return "seersucker-blue";
    } else if (pathname.startsWith("/registry")) {
      return "blue";
    } else if (pathname.startsWith("/pictures")) {
      return "blue";
    } else if (pathname.startsWith("/transportation")) {
      return "seersucker-blue";
    } else if (pathname.startsWith("/rsvp")) {
      return "green";
    } else if (pathname.startsWith("/admin")) {
      return "black";
    } else {
      return "blue";
    }
  }

  const pinstripeColor = pinstripesColorForPage(location.pathname) || "blue";

  return (
    <>
      <div className="centered-box">
        <div className={`pinstripes ${pinstripeColor} crane-nav-header`}>
          <div className="crane-logo-button-group">
            <NavLink to="/" onClick={closeSidebar}>
              <div className="crane-logo-div">
                <img src={ivory_crane} className="crane-wedding-logo" />
                <p className="navy-blue crane-wedding-logo-title">
                  the Cranes
                </p>
              </div>
            </NavLink>
          </div>
        </div>

        <a onClick={toggleSidebar} className='nav-menu'>
          <div className='nav-menu-div mobile-only'>
            <p className='navy-blue nav-menu-title'>MENU</p>
          </div>
        </a>
        <NavLink to="/pictures">
          <div className='nav-rsvp-div desktop-only'>
            <p className='navy-blue nav-rsvp-title'>Pictures</p>
          </div>
        </NavLink>


        <div className={`sidebar ${isSidebarOpen ? "open" : ""}`}>
          <button className="close-button" onClick={toggleSidebar}>
            ×
          </button>
          <nav className="menu-nav">
            <NavLink
              to="/pictures"
              onClick={closeSidebar}
              className={({ isActive }) =>
                isActive ? "wedding-nav-link selected" : "wedding-nav-link"
              }
            >
              <b>Pictures</b>
            </NavLink>

            {navPages.map((page) => (
              <NavLink
                to={page.link}
                onClick={closeSidebar}
                className={({ isActive }) =>
                  isActive ? "wedding-nav-link selected" : "wedding-nav-link"
                }
              >
                {page.name}
              </NavLink>
            ))}
          </nav>
        </div>

        {/* Optional overlay when menu is open */}
        {isSidebarOpen && <div className="overlay" onClick={closeSidebar} />}

        <div className="color-break dark-blue"></div>
      </div>

      <div className="centered-box desktop-only">
        <div className="wedding-nav-links">
          {navPages.map((page) => (
            <NavLink
              to={page.link}
              end
              className={({ isActive }) =>
                isActive ? "wedding-nav-link selected" : "wedding-nav-link"
              }
            >
              {page.name}
            </NavLink>
          ))}
        </div>

        <div className="color-break dark-blue"></div>
      </div>
    </>
  );
};

export default NavMenu;
